import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

export const MbjRadioGroup = RadioGroupPrimitive.Root;
